import React, { useCallback, useEffect, useState } from 'react';
import './UploadS3.scss';
import { fileToDataUri } from '../../utils/file';
import { fileUpload } from '../../utils/file';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import AWS from 'aws-sdk';
import { getConfigAws } from '../../services/auth';

const UploadS3 = props => {

    const [file, setFile] = useState(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [fileInProcess, setFileInProcess] = useState(false);

    const configAWS = useCallback(async () => {
        const result = await getConfigAws();
        AWS.config.update(result);
    },[]); 

    useEffect(()=>{
        const run = async () =>{
            await configAWS();
        }
        run();
    },[configAWS]);

    const addFile = async e => {
        setFileInProcess(true);
        const file = e.target.files[0];
        const data = await fileToDataUri(e.target.files[0]);
        const params = { name: file.name, data };
        if (data) {
            const fileToUp = fileUpload(params);
            
            if(props.extensions){
                if (!props.extensions.includes(fileToUp.ext.toString().toLowerCase())){
                    alert('Arquivo do tipo ('+fileToUp.ext + ') não é permitido');
                    setFileInProcess(false);
                    return;
                }
            }
            
            setFile(fileToUp);
            startUpload(fileToUp)
            .on('httpUploadProgress', (progress) => {
                let progressPercentage = Math.round(progress.loaded / progress.total * 100);
                updateProgress(progressPercentage);
            });
        }
    }

    const updateProgress = (p) => {
        document.querySelector('#percentual_0').innerText = p + '%';
    }

    const startUpload = file => {
        setFileInProcess(false);
        setUploadInProgress(true);
        const bucket = new AWS.S3({ params: { Bucket: props.bucket } });
        const buff = Buffer.from(file.base64, 'base64');
        var data = {
            Key: props.folder + '/' + Date.now() + '.' + file.ext,
            Body: buff,
            ACL: 'public-read',
            ContentEncoding: 'base64',
            ContentType: file.mimeType
        }
        return bucket.upload(data, (err, returnData) => {
            if (err) {
                console.log(err);
            } else {
                props.callback(file,returnData);
                setFile(null);
                setUploadInProgress(false);
            }
        })
    }

    const renderFiles = _ => {
        if(file?.name){
            return (
                <div className="item">
                    <div className="icon">
                        <Icon icon={faFile} />
                    </div>
                    <div className="name">{file.name}</div>
                    <div className="progress"><span id={`percentual_0`}>0%</span></div>
                </div>
            )
        }
    }

    const selectFile = e => {
        document.querySelector('#inputFile').click();
    }

    return (
        <div className="uploadS3">
            <input id="inputFile" type="file" onChange={e => addFile(e)} />
            { !uploadInProgress && 
                <button type="button" 
                    disabled={fileInProcess} 
                    onClick={selectFile}>
                    {props.label || "Selecione um arquivo"}
                </button>
            }
            <div className="files">
                {renderFiles()}
            </div>
        </div>
    );
};

export default UploadS3;